exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ant-modal-title {\n  font-size: 20px; }\n\n.ant-modal-body {\n  padding: 60px; }\n", ""]);

